(function () {
  const overlay = document.querySelector("[data-site-intro]");
  const stage = document.querySelector("[data-intro-logo]");
  const navLogo = document.querySelector(".nav-logo-link");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  let introDone = false;
  const signalIntroDone = () => {
    if (introDone) return;
    introDone = true;
    window.dispatchEvent(new CustomEvent("site-intro-done"));
  };

  if (!overlay || !stage || !navLogo || reducedMotion) {
    overlay?.remove();
    signalIntroDone();
    return;
  }

  const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));
  const blockIntroScroll = (event) => event.preventDefault();
  overlay.addEventListener("wheel", blockIntroScroll, { passive: false });
  overlay.addEventListener("touchmove", blockIntroScroll, { passive: false });

  const modelReady = new Promise((resolve) => {
    if (window.__pouchModelReady) {
      resolve();
      return;
    }

    const timeout = window.setTimeout(resolve, 2400);
    window.addEventListener(
      "pouch-model-ready",
      () => {
        window.clearTimeout(timeout);
        resolve();
      },
      { once: true },
    );
  });

  async function loadLogo() {
    try {
      const response = await fetch(window.TwoFourSixAssets.logo, { cache: "force-cache" });
      if (!response.ok) throw new Error("Logo request failed");
      stage.innerHTML = await response.text();
      const svg = stage.querySelector("svg");
      if (!svg) throw new Error("Logo SVG missing");
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("overflow", "visible");
      svg.style.overflow = "visible";
      svg.querySelectorAll("path").forEach((path, index) => {
        path.classList.add("intro-glyph");
        path.style.setProperty("--glyph-index", index);
        path.setAttribute("fill", "#EE328A");
      });
    } catch (error) {
      stage.innerHTML = `<img src="${window.TwoFourSixAssets.logo}" alt="" aria-hidden="true">`;
    }
  }

  async function flyToNav() {
    const startRect = stage.getBoundingClientRect();
    const targetRect = navLogo.getBoundingClientRect();
    const startX = startRect.left + startRect.width / 2;
    const startY = startRect.top + startRect.height / 2;
    const targetX = targetRect.left + targetRect.width / 2;
    const targetY = targetRect.top + targetRect.height / 2;
    const travelX = targetX - startX;
    const travelY = targetY - startY;
    const targetScale = Math.max(0.01, targetRect.width / startRect.width);

    stage.style.left = `${startX}px`;
    stage.style.top = `${startY}px`;
    stage.style.transform = "translate3d(-50%, -50%, 0) translate3d(0, 0, 0) scale(1)";

    const animation = stage.animate(
      [
        {
          transform: "translate3d(-50%, -50%, 0) translate3d(0, 0, 0) scale(1)",
        },
        {
          transform: `translate3d(-50%, -50%, 0) translate3d(${travelX}px, ${travelY}px, 0) scale(${targetScale})`,
        },
      ],
      {
        duration: 780,
        easing: "cubic-bezier(0.16, 0.9, 0.22, 1)",
        fill: "forwards",
      },
    );

    await Promise.race([animation.finished.catch(() => {}), sleep(860)]);
    stage.style.transform = `translate3d(-50%, -50%, 0) translate3d(${travelX}px, ${travelY}px, 0) scale(${targetScale})`;
  }

  async function runIntro() {
    document.body.classList.add("intro-running");
    const hardStop = window.setTimeout(() => {
      document.body.classList.remove("intro-running");
      overlay.remove();
      signalIntroDone();
    }, 4200);

    await loadLogo();
    await Promise.all([sleep(1550), modelReady]);
    await flyToNav();
    overlay.classList.add("is-exiting");
    await sleep(380);
    window.clearTimeout(hardStop);
    document.body.classList.remove("intro-running");
    overlay.remove();
    signalIntroDone();
  }

  runIntro().catch(() => {
    document.body.classList.remove("intro-running");
    overlay.remove();
    signalIntroDone();
  });
})();
